import { render, staticRenderFns } from "./CustomClue.vue?vue&type=template&id=21469c93&scoped=true"
import script from "./CustomClue.vue?vue&type=script&lang=js"
export * from "./CustomClue.vue?vue&type=script&lang=js"
import style0 from "./CustomClue.vue?vue&type=style&index=0&id=21469c93&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21469c93",
  null
  
)

export default component.exports